import { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../../manager'
import CreationToolUploadField from '../../../../types/upload-field'
import CreationToolUserRestriction from '../../../../types/user-restriction'
import Description from '../../fields/description'
import SourceUrl from '../../fields/source-url'
import Tags from '../../fields/tags'
import { CreationToolUploadSource } from '../../types'

const FIELDS = [
    CreationToolUploadField.VideoDescription,
    CreationToolUploadField.Tags,
    CreationToolUploadField.SourceUrl,
]

const Container = styled.div`
    padding: 20px 15px;

    > div {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`

type Props = {
    source: CreationToolUploadSource
    isBulk: boolean
}

const CreationUploadItemFields = ({ source, isBulk }: Props) => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const { outputType, id } = source
    const fields = isBulk
        ? FIELDS.filter((field) => {
              const userRestriction = CreationToolUploadField.userRestriction(field)
              const outputTypeRestrictions = CreationToolUploadField.ouputTypeRestrictions(field)
              const hasAccess = CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
              return hasAccess && outputTypeRestrictions.indexOf(outputType) > -1
          })
        : [] // only need to show individual item fields if we are bulk uploading

    // map upload fields to components
    const fieldComponents = fields.map((field) => {
        switch (field) {
            case CreationToolUploadField.Tags:
                return Tags
            case CreationToolUploadField.VideoDescription:
                return Description
            case CreationToolUploadField.SourceUrl:
                return SourceUrl
        }
    })

    return fieldComponents.length > 0 ? (
        <Container>
            {fieldComponents.map((Field, i) =>
                Field ? <Field key={fields[i]} field={fields[i]} sourceId={id} /> : null
            )}
        </Container>
    ) : null
}

export default CreationUploadItemFields
